import {isNil} from 'ramda';

import {GetTenantV2ApiRes} from '@dms/api/base';
import {GetCurrentUserInfoApiResponse} from '@dms/api/shared';
import {getNaturalPersonFullName} from '@dms/shared';

import {Nullish} from 'shared/web';

import {DefaultSignatoriesFormData} from '../types/DefaultSignatoriesFormData';
import {getTrimmedFormValue} from './getTrimmedFormValue';

export const getCurrentUserSignatoryDefaults = (
  currentUser: GetCurrentUserInfoApiResponse | Nullish,
  tenant: Pick<GetTenantV2ApiRes, 'publicContacts'> | Nullish
): DefaultSignatoriesFormData[string] | null => {
  if (isNil(currentUser)) {
    return null;
  }

  const phoneNumber = currentUser.phoneNumber;
  const tenantFallbackPhoneNumber = currentUser.phoneNumber ?? tenant?.publicContacts?.phoneNumber;

  return {
    id: currentUser.id,
    name: getNaturalPersonFullName(currentUser) ?? '',
    email: getTrimmedFormValue(currentUser.email),
    phoneNumber: {
      countryCode: getTrimmedFormValue(tenantFallbackPhoneNumber?.countryCode),
      number: getTrimmedFormValue(phoneNumber?.number),
      prefix: getTrimmedFormValue(tenantFallbackPhoneNumber?.prefix),
    },
  };
};
